/**
 * 권한을 Canonical Name 배열로 관리한다.
 */
import {isNOU} from "@/assets/plugins/mps-common/expansions/condition";

class PermissionList {
    _permissions = [];

    constructor(permissions) {
        this._permissions = permissions;
    }

    /**
     * 넘어온 권한을 해당 유저가 모두 가지고 있는지 체크합니다.
     *
     * null, undefined: true
     * 배열: length 가 0이면 true 아니면 모든 권한을 체크하여 하나라도 있다면 true, 어떠한 권한도 해당되지 않으면 false
     * 단일 권한: 권한을 가지고 있는지 체크
     *
     * @param canonicalPermissionName
     * @returns {boolean}
     */
    findNodeByCanonicalName(canonicalPermissionName) {
        if (isNOU(canonicalPermissionName)) return true; // null 이나 undefined 이면 true를 반환합니다.
        if (Array.isArray(canonicalPermissionName)) { // 배열이면 모든 권한이 다 있는지 체크합니다.
            if (canonicalPermissionName.length === 0) return true; // 파라미터로 넘어온 권한 배열의 length 가 0 이면 true를 반환합니다.
            for (const i in canonicalPermissionName) {
                if (this._permissions.includes(canonicalPermissionName[i])) return true; // 권한이 하나라도 있다면 true 아니면 false
            }
            return false; // 해당되는 권한이 없다면 false 리턴
        } else { // 단일 권한 체크
            return this._permissions.includes(canonicalPermissionName);
        }
    }
}

class PermissionCanonicalNameManager {

    _list;

    constructor(permissions = []) {
        this.setPermissions(permissions);
    }

    setPermissions(permissions) {
        this._list = new PermissionList(permissions);
    }

    hasPermission(canonicalPermissionName) {
        return this.hasPermissionByCanonicalName(canonicalPermissionName);
    }

    hasPermissionByCanonicalName(canonicalPermissionName) {
        return !!this._list.findNodeByCanonicalName(canonicalPermissionName);
    }
}


const permissionCanonicalNameManager = new PermissionCanonicalNameManager();
export {permissionCanonicalNameManager}
